export default {
  indexEndpoint: '/customer-contact/',
  indexBranchesEndpoint: '/customer-contact-branches/',
  storeEndpoint: '/customer-contact',
  editEndpoint: '/customer-contact-show/',
  updateEndpoint: '/customer-contact/',
  deleteEndpoint: '/customer-contact/',
}
